<template>
  <div class="core-box">
    <el-form
      label-position="left"
      label-width="90px"
      :ref="refName"
      :inline="true"
      hide-required-asterisk
      :style="{ height: heights }"
      style="position: relative; overflow: hidden"
      :size="formSize"
      :model="value"
    >
      <template style="display: inline-block" v-for="(form, index) in formConfig.list">
        <dynamic-input
          v-if="form.type === 'input' && form.options.dataType === 'string'"
          :form="form"
          :key="index"
          @input="onChildChange"
          v-model="value"
          @init="targetInit"
          :disabled="disabled"
          :forms="forms"
        ></dynamic-input>

        <dynamic-input-integer
          v-if="form.type === 'input' && form.options.dataType === 'integer'"
          :form="form"
          :key="index"
          @input="onChildChange"
          v-model="value"
          @init="targetInit"
          :disabled="disabled"
          :forms="forms"
        ></dynamic-input-integer>

        <dynamic-input-number
          v-if="form.type === 'number'"
          :form="form"
          :key="index"
          @input="onChildChange"
          v-model="value"
          @init="targetInit"
          :disabled="disabled"
          :forms="forms"
        ></dynamic-input-number>
        <long-and-lat
          v-if="form.type === 'longandlat'"
          :form="form"
          :key="index"
          @input="onChildChange"
          v-model="value"
          @init="targetInit"
          :disabled="disabled"
          :forms="forms"
        ></long-and-lat>
        <num-to-num
          v-if="form.type === 'numtonum'"
          :form="form"
          :key="index"
          @input="onChildChange"
          v-model="value"
          @init="targetInit"
          :disabled="disabled"
          :forms="forms"
        ></num-to-num>
        <MeasureNumber
          v-if="form.type === 'measureNumber'"
          :form="form"
          :key="index"
          @input="onChildChange"
          v-model="value"
          @init="targetInit"
          :disabled="disabled"
          :forms="forms"
        ></MeasureNumber>

        <input-stake
          v-if="form.type === 'stake'"
          :form="form"
          :key="index"
          @input="onChildChange"
          v-model="value"
          @init="targetInit"
          :disabled="disabled"
          :forms="forms"
        ></input-stake>
        <CenterStake
          v-if="form.type === 'centerstake'"
          :form="form"
          :key="index"
          @input="onChildChange"
          v-model="value"
          @init="targetInit"
          :disabled="disabled"
          :forms="forms"
        ></CenterStake>

        <dynamic-textarea
          v-if="form.type === 'textarea'"
          :form="form"
          :key="index"
          @input="onChildChange"
          v-model="value"
          @init="targetInit"
          :disabled="disabled"
          :forms="forms"
        ></dynamic-textarea>

        <dynamic-radio
          v-if="form.type === 'radio'"
          :form="form"
          :key="index"
          @input="onChildChange"
          v-model="value"
          @init="targetInit"
          :disabled="disabled"
          :forms="forms"
        ></dynamic-radio>

        <dynamic-select
          v-else-if="form.type === 'select'"
          :form="form"
          :key="index"
          @input="onChildChange"
          v-model="value"
          @init="targetInit"
          :disabled="disabled"
          :forms="forms"
        ></dynamic-select>

        <dynamic-cascader
          v-else-if="form.type === 'cascader'"
          :form="form"
          :key="index"
          @input="onChildChange"
          :value="value"
          @init="targetInit"
          :disabled="disabled"
          :forms="forms"
        ></dynamic-cascader>

        <!-- <org-cascader v-else-if="form.type === 'org'" :form="form" :key="index"
                    @input="onChildChange" :value="value" @init="targetInit"
                    :disabled="disabled"
                    :forms="forms"></org-cascader>      -->

        <pers-cascader
          v-else-if="form.type === 'pers'"
          :form="form"
          :key="index"
          @input="onChildChange"
          :value="value"
          @init="targetInit"
          :disabled="disabled"
          :forms="forms"
        ></pers-cascader>
        <!--
                                <area-cascader v-else-if="form.type === 'area'" :form="form" :key="index"
                                    @input="onChildChange" :value="value" @init="targetInit"
                                    :disabled="disabled"
                                    :forms="forms"></area-cascader>   -->

        <dynamic-date-picker
          v-else-if="form.type === 'date'"
          :form="form"
          :key="index"
          @input="onChildChange"
          :value="value"
          @init="targetInit"
          :disabled="disabled"
          :forms="forms"
        ></dynamic-date-picker>
        <dynamic-time-picker
          v-else-if="form.type === 'time'"
          :form="form"
          :key="index"
          @input="onChildChange"
          :value="value"
          @init="targetInit"
          :disabled="disabled"
          :forms="forms"
        >
        </dynamic-time-picker>
        <dynamic-switch
          v-else-if="form.type === 'switch'"
          :form="form"
          :key="index"
          :value="value"
          :disabled="disabled"
          @input="onChildChange"
          @init="targetInit"
          :forms="forms"
        ></dynamic-switch>
        <select-icon
          v-else-if="form.type === 'icon-select'"
          :form="form"
          :key="index"
          :value="value"
          :disabled="disabled"
          @input="onChildChange"
          @init="targetInit"
          :forms="forms"
        >
        </select-icon>
        <dynamic-files-upload
          v-else-if="form.type === 'fileupload'"
          :form="form"
          :key="index"
          :value="value"
          :disabled="disabled"
          @input="onChildChange"
          @init="targetInit"
          :forms="forms"
        ></dynamic-files-upload>
        <dynamic-img-upload
          v-else-if="form.type === 'imageupload'"
          :form="form"
          :key="index"
          :value="value"
          :disabled="disabled"
          @input="onChildChange"
          @init="targetInit"
          :forms="forms"
        ></dynamic-img-upload>
        <dynamic-img
          v-else-if="form.type === 'image'"
          :form="form"
          :key="index"
          :value="value"
          :disabled="disabled"
          @input="onChildChange"
          @init="targetInit"
          :forms="forms"
        ></dynamic-img>
        <OrgTree
          v-else-if="form.type === 'org'"
          :key="index"
          :disabled="disabled"
          :form="form"
          :forms="forms"
          :value.sync="value"
        ></OrgTree>
        <personOrgTree
          v-else-if="form.type === 'psOrg'"
          :key="index"
          :disabled="disabled"
          :form="form"
          :forms="forms"
          :value.sync="value"
        ></personOrgTree>
        <AreaTree
          v-else-if="form.type === 'area'"
          :key="index"
          :disabled="disabled"
          :form="form"
          :forms="forms"
          :value.sync="value"
        ></AreaTree>
        <ProjectTree
          v-else-if="form.type === 'pro'"
          :key="index"
          :disabled="disabled"
          :form="form"
          :forms="forms"
          :value.sync="value"
        ></ProjectTree>
        <WorkDiction
          v-else-if="form.type === 'work'"
          :key="index"
          :disabled="disabled"
          :form="form"
          :forms="forms"
          :value.sync="value"
        ></WorkDiction>
        <newDictionary
          v-else-if="form.type === 'selectDic'"
          :key="index"
          :disabled="disabled"
          :form="form"
          :forms="forms"
          :value.sync="value"
        ></newDictionary>
        <newDictionary2
          v-else-if="form.type === 'selectDic2'"
          :key="index"
          :disabled="disabled"
          :form="form"
          :forms="forms"
          :value.sync="value"
        ></newDictionary2>
        <template v-else-if="form.type === 'yjjSlot'" style="display: inline-block">
          <slot name="yjj_zy"></slot>
        </template>
        <template v-else-if="form.type === 'yjjSlot1'" style="display: inline-block">
          <slot name="yjj_zy1"></slot>
        </template>
      </template>
    </el-form>
  </div>
</template>
<script>
import DynamicInput from "./DynamicInput"; //普通文本输入
import DynamicInputNumber from "./DynamicInputNumber"; //计数器
import DynamicInputInteger from "./DynamicInputInteger";
import DynamicRadio from "./DynamicRadio"; //单选
import DynamicTextarea from "./DynamicTextarea"; //长文本
import DynamicSelect from "./DynamicSelect"; //下拉选择
import DynamicCascader from "./DynamicCascader"; //级联菜单
import DynamicDatePicker from "./DynamicDatePicker"; //日期选择
import DynamicTimePicker from "./DynamicTimePicker"; //时间选择
import DynamicSwitch from "./DynamicSwitch"; //开关
import InputStake from "../Customize/InputStake"; //桩号输入
import CenterStake from "../Customize/CenterStake"; //中心桩号
//import OrgCascader from '../Customize/OrgCascader' //组织机构
// import AreaCascader from '../Customize/AreaCascader' //区域选择
import PersCascader from "../Customize/PersCascader"; //菜单选择
import NumToNum from "../Customize/NumToNum"; //数字范围填写
import MeasureNumber from "../Customize/MeasureNumber"; //多单位数量填写
import SelectIcon from "../Customize/SelectIcon"; //图标选择
import LongAndLat from "../Customize/LongAndLat"; //经纬度
import DynamicFilesUpload from "./DynamicFilesUpload"; //文件上传
import DynamicImgUpload from "./DynamicImgUpload"; //文件上传
import DynamicImg from "./DynamicImg"; //图片上传
import OrgTree from "@/components/DynamicPages/Customize/OrgTree";
import AreaTree from "@/components/DynamicPages/Customize/AreaTree";
import ProjectTree from "@/components/DynamicPages/Customize/ProjectTree";
import WorkDiction from "@/components/DynamicPages/Customize/WorkDiction";
import personOrgTree from "@/components/DynamicPages/Customize/personOrgTree";
import newDictionary from "@/components/DynamicPages/Customize/newDictionary";
import newDictionary2 from "@/components/DynamicPages/Customize/newDictionary2";

export default {
  name: "DynamicForm",
  components: {
    DynamicCascader,
    DynamicTextarea,
    DynamicInput,
    InputStake,
    CenterStake,
    DynamicInputInteger,
    DynamicRadio,
    DynamicInputNumber,
    DynamicSelect,
    DynamicDatePicker,
    DynamicTimePicker,
    DynamicSwitch,

    //            AreaCascader,
    PersCascader,
    NumToNum,
    MeasureNumber,
    SelectIcon,
    DynamicFilesUpload,
    DynamicImgUpload,
    DynamicImg,
    LongAndLat,
    OrgTree,
    AreaTree,
    ProjectTree,
    WorkDiction,
    personOrgTree,
    newDictionary,
    newDictionary2,
  },
  data: function () {
    return {
      forms: {
        targets: [],
        getKey(key) {
          for (let i = 0; i < this.targets.length; i++) {
            if (this.targets[i].key === key) {
              return this.targets[i];
            }
          }
        },
        refName: "",
      },
      formData: {},
      options: [
        {
          label: "",
          value: "",
        },
      ],
      ruleForm: {
        // 存储数据
        name: "",
      },
    };
  },
  props: {
    formConfig: {
      type: Object,
      default() {
        return { list: [] };
      },
    },
    value: {
      type: Object,
    },
    heights: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    formSize() {
      if (!this.formConfig.config || typeof this.formConfig.config.size === "undefined") {
        return "";
      } else {
        return this.formConfig.config.size;
      }
    },
  },
  methods: {
    submit() {
      let that = this;
      return new Promise((resolve, reject) => {
        that.$refs[that.refName].validate((valid) => {
          if (valid) {
            // if (that.$refs[that.refName].model.startStake > that.$refs[that.refName].model.endStake) {
            //     this.$message({
            //         showClose: true,
            //         message: '起点桩号应小于止点桩号',
            //         type: 'warning'
            //     });
            //     return false
            // } else {
            //     resolve(valid)
            // }
            resolve(valid);
          } else {
            this.$message({
              showClose: true,
              message: "请检查表单内容是否正确!",
              type: "warning",
            });
            reject(valid);
            return false;
          }
        });
      });
    },
    clearForm() {
      let that = this;
      const list = ["parentId", "type", "isPublic", "isEnable"]; //过滤不重置的字段
      let form = that.$refs[that.refName].model;
      for (let i in form) {
        if (typeof form[i] === "string") {
          if (list.includes(i)) {
            form[i] = form[i];
          } else {
            form[i] = "";
          }
        } else if (Array.isArray(form[i])) {
          form[i] = [];
        } else {
          if (list.includes(i)) {
            form[i] = form[i];
          } else {
            form[i] = 0;
          }
        }
      }
      that.$nextTick(() => {
        that.$refs[that.refName].clearValidate();
      });
    },
    resetForm(callback) {
      let that = this;
      // that.$refs[that.refName].resetFields()
      const _resetForm = function () {
        let form = that.$refs[that.refName].model;
        for (let i in form) {
          if (typeof form[i] === "number") {
            form[i] = 0;
          } else if (Array.isArray(form[i])) {
            form[i] = [];
          } else {
            form[i] = "";
          }
        }
      };
      that.$refs[that.refName].clearValidate();
      if (callback) {
        _resetForm();
        callback();
      } else {
        return new Promise((resolve, reject) => {
          _resetForm();
          resolve();
        });
      }
    },
    onChildChange($value, key) {
      this.$emit("input", this.value);
    },
    targetInit(key, target) {
      this.forms.targets.push(target);
    },
    popoverShow(val) {
      this.$emit("popoverShow", val);
    },
  },
  created() {
    this.refName = "form" + new Date().getTime();
  },
  watch: {},
};
</script>
<style scoped>
.form-bg {
  background-color: #fff;
}

.core-box {
  margin-top: 10px;
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/DynamicPages/Form/DynamicForm.vue"
}
</vue-filename-injector>
